module.exports = __webpack_public_path__ + "static/media/flixbus-card.7b4c66a6.png";